module.exports = __webpack_public_path__ + "assets/img/index-partner19.da405ae8.jpg";